import ReactOnRails from 'react-on-rails';

import App from './components/App/index';
import { PrimaryButton, SecondaryButton } from './components/Button/variants';
import Byline from './components/Byline';
import BylineWithHeadshot from './components/BylineWithHeadshot';
import Clipper from './components/Clipper';
import DatabaseProjectTitle from './components/DatabaseProjectTitle/index';
import EmailConfirmation from './components/EmailConfirmation/index';
import EnableProfileModal from './components/EnableProfileModal/index';
import EventFollowBanner from './components/Events/EventFollowBanner/index';
import PastEventsList from './components/Events/PastEventsList/index';
import FollowButtonWithQueryClientWrapper from './components/FollowButton/FollowButtonWithQueryClientWrapper';
import Footer from './components/Footer/index';
import FieldLabel from './components/Form/FieldLabel';
import HorizontalLogoDivider from './components/HorizontalLogoDivider';
import IconClose from './components/Images/Rebranding/IconClose';
import IconFacebook from './components/Images/Rebranding/IconFacebook';
import IconOrgChart from './components/Images/Rebranding/IconOrgChart';
import IconProTagArticle from './components/Images/Rebranding/IconProTagArticle';
import IconTI from './components/Images/Rebranding/IconTI';
import IconTheWeekend from './components/Images/Rebranding/IconTheWeekend';
import IconThreads from './components/Images/Rebranding/IconThreads';
import IconX from './components/Images/Rebranding/IconX';
import LogoTIProWithIconTI from './components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from './components/Images/Rebranding/LogoTIWithIconTI';
import LockedLeadCaptureFormMarketingLeadCaptureWithGoogle from './components/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import LockedLeadCaptureForm from './components/LockedLeadCaptureForm/index';
import MarketingModal from './components/MarketingModal/index';
import MessageUserButton from './components/MessageUserButton/index';
import Nav from './components/Nav/index';
import NewsletterFeedBanner from './components/Newsletter/NewsletterFeedBanner/index';
import OnboardingModal from './components/OnboardingModal/index';
import ProExclusiveLogo from './components/ProExclusiveLogo/index';
import SocialLinks from './components/SocialLinks/index';
import StickyBannerBottom from './components/StickyBanner/Bottom';
import StickyBannerTop from './components/StickyBanner/Top';
import StickyBannerUserStatus from './components/StickyBanner/Top/UserStatus';
import TIHeader from './components/TIHeader';
import Team from './components/Team';
import TopicDescription from './components/Topic/TopicDescription/index';
import TopicFollowAndTagModal from './components/Topic/TopicFollowAndTagModal/index';
import ViewInAppModal from './components/ViewInAppModal/index';
import ArticlePage from './components/pages/Article';
import Briefing from './components/pages/Briefing/index';
import CancelFeedback from './components/pages/CancelFeedback/index';
import CorporateLanding from './components/pages/CorporateLanding/index';
import CryptoPowerlist from './components/pages/CryptoPowerlist/index';
import EnterprisePowerlistHeader from './components/pages/EnterprisePowerlist/Header';
import EnterprisePowerlist from './components/pages/EnterprisePowerlist/index';
import EventInfo from './components/pages/EventInfo';
import TopicForumPosts from './components/pages/Forum/TopicForumPosts/index';
import Gift from './components/pages/Gift/index';
import Highlight from './components/pages/Highlight';
import Home from './components/pages/Home';
import OrgSignUp from './components/pages/OrgSignUp/index';
import Partners from './components/pages/Partners';
import ProMarketingCTAs from './components/pages/Pro/ProMarketingCTAs';
import Pro from './components/pages/Pro/index';
import ReadUsFirst from './components/pages/ReadUsFirst/index';
import ReferralLanding from './components/pages/Referral/Landing/index';
import ReferralSubscription from './components/pages/Referral/Subscription/index';
import SearchPage from './components/pages/SearchPage/index';
import SettingsUserProfile from './components/pages/Settings/UserProfile/index';
import Subscribe from './components/pages/Subscribe/index';
import SubscriptionLanding from './components/pages/SubscriptionLanding/index';
import SubscriptionTeam from './components/pages/Team/index';

ReactOnRails.register({
  App,
  Briefing,
  Byline,
  BylineWithHeadshot,
  Clipper,
  CorporateLanding,
  CryptoPowerlist,
  CancelFeedback,
  ViewInAppModal,
  EmailConfirmation,
  EnableProfileModal,
  EnterprisePowerlist,
  EnterprisePowerlistHeader,
  EventInfo,
  EventFollowBanner,
  ArticlePage,
  FieldLabel,
  FollowButtonWithQueryClientWrapper,
  Footer,
  Gift,
  Highlight,
  Home,
  HorizontalLogoDivider,
  IconClose,
  IconFacebook,
  IconOrgChart,
  IconProTagArticle,
  IconTheWeekend,
  IconThreads,
  IconTI,
  IconX,
  LockedLeadCaptureForm,
  LockedLeadCaptureFormMarketingLeadCaptureWithGoogle,
  LogoTIProWithIconTI,
  LogoTIWithIconTI,
  MarketingModal,
  MessageUserButton,
  Nav,
  NewsletterFeedBanner,
  OnboardingModal,
  OrgSignUp,
  Partners,
  PastEventsList,
  PrimaryButton,
  Pro,
  ProExclusiveLogo,
  DatabaseProjectTitle,
  ProMarketingCTAs,
  ReadUsFirst,
  ReferralLanding,
  ReferralSubscription,
  SearchPage,
  SecondaryButton,
  SettingsUserProfile,
  SocialLinks,
  StickyBannerTop,
  StickyBannerBottom,
  StickyBannerUserStatus,
  Subscribe,
  SubscriptionTeam,
  SubscriptionLanding,
  Team,
  TIHeader,
  TopicDescription,
  TopicFollowAndTagModal,
  TopicForumPosts,
});
